import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './PatientInfo.css';

const Component = ({ patient, vetPractice }) => (
  <div className={styles.container}>
    <span className={styles.info}>{patient}</span>
    <div className={styles.divider} />
    <span className={styles.info}>{vetPractice}</span>
  </div>
);

Component.propTypes = {
  patient: PropTypes.string.isRequired,
  vetPractice: PropTypes.string.isRequired,
};

export default Component;



// WEBPACK FOOTER //
// ./src/components/PatientInfo.jsx